import React, { useState } from 'react';

import { style } from '../MakeOffer/Elements';
import { RedButton, AddGrid, SendButton } from './Elements';
import { Modal, Box, Grid, TextField } from '@mui/material';
import { DashedUploadBox, UploadText } from '../Join/Components/Elements';
import { messageInputStyles } from '../../components/InputFields/styles';

import { Header } from '../../components/Modal/ModalHeader';
import cross from '../../assets/profile/cross.png';
import add from '../../assets/createTrip/add.png';
import send from '../../assets/messaging/send.png';
import upload from '../../assets/create account/upload.png';

const ImageUpload = ({ sendImage, open, handle, _state, uploadFunction, stateName, _setState }) => {
  const classes = messageInputStyles();

  const [state, setState] = useState({});
  const [isDragOver, setIsDragOver] = useState(false);

  const handleChange = (name, value) => {
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleClose = () => {
    _setState((prevState) => {
      return { ...prevState, image: [] };
    });
    handle([stateName], false);
    setIsDragOver(false);
  };

  const deleteImage = async (index) => {
    // let arr = [..._state.image];
    // console.log(arr);
    // arr.splice(index, 1);
    // const updateArray = arr.splice(index, 1);
    // console.log(arr);
    // handleChange('image', updateArray);
    _setState((prevState) => {
      const updatedImages = [...prevState.image];
      updatedImages.splice(index, 1);
      return { ...prevState, image: updatedImages };
    });
    // console.log('updateArray', updateArray);
    console.log('_state', _state.image);
  };

  // Drag and drop handlers
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);

    const files = Array.from(e.dataTransfer.files);
    const imageFiles = files.filter(file => 
      file.type.startsWith('image/') && 
      ['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)
    );

    if (imageFiles.length > 0) {
      // Create a synthetic event to pass to uploadFunction
      const syntheticEvent = {
        target: {
          files: imageFiles
        }
      };
      uploadFunction(syntheticEvent);
    }
  };
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            ...style,
            width: _state?.image?.length > 0 ? '400px' : '388px',
            maxHeight: '80vh',
            height: 'max-content',
            justifyContent: 'center',
            alignItems: 'center',
            px: 3,
            py: 2,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Header handleClose={handleClose} heading="Add Chat Photos" />
          <Box
            sx={{
              flex: 1,
              overflow: 'auto',
              // width: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {_state?.image?.length > 0 ? (
              <Grid
                container
                sx={{ 
                  display: 'flex', 
                  justifyContent: 'flex-start', 
                  alignItems: 'flex-start', 
                  my: 2,
                  border: isDragOver ? '2px dashed #007bff' : '2px dashed transparent',
                  backgroundColor: isDragOver ? 'rgba(0, 123, 255, 0.1)' : 'transparent',
                  borderRadius: '8px',
                  padding: '8px',
                  transition: 'all 0.3s ease',
                  minHeight: '120px',
                  maxHeight: '50vh',
                  overflow: 'auto'
                }}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                {_state?.image?.map((res, i) => {
                  return (
                    <Grid
                      key={i}
                      item
                      xs={4}
                      sm={3}
                      md={3}
                      lg={2.9}
                      className="uploadImageModal"
                      sx={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        alignItems: 'center', 
                        mt: 1,
                        mb: 1
                      }}
                    >
                      <img 
                        src={res} 
                        alt="images" 
                        style={{
                          width: '100%',
                          height: '80px',
                          objectFit: 'cover',
                          borderRadius: '4px'
                        }}
                      />
                      <button className="closeallimageParent" onClick={() => deleteImage(i)}>
                        <img src={cross} alt="cross" />
                      </button>
                    </Grid>
                  );
                })}
                <AddGrid item xs={4} sm={3} md={3} lg={2.9} className="allimageParent">
                  <label className="filebutton">
                    <img src={add} alt="add" />
                    <span>
                      <input
                        accept="image/png,image/jpg, image/jpeg"
                        multiple={true}
                        type="file"
                        id="myfile"
                        onChange={uploadFunction}
                        style={{ display: 'none' }}
                        name="myfile"
                      />
                    </span>
                  </label>
                </AddGrid>
              </Grid>
            ) : (
              <DashedUploadBox
                sx={{
                  my: 4,
                  height: 80,
                  width: 200,
                  flexDirection: 'row',
                  alignItems: 'center',
                  pt: 0,
                  border: isDragOver ? '2px dashed #007bff' : '2px dashed #ccc',
                  backgroundColor: isDragOver ? 'rgba(0, 123, 255, 0.1)' : 'transparent',
                  transition: 'all 0.3s ease',
                }}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <label className="filebutton" style={{ cursor: 'pointer', marginRight: 10 }}>
                  <img src={upload} alt="upload" />
                  <span>
                    <input
                      accept="image/png,image/jpg, image/jpeg"
                      type="file"
                      id="myfile"
                      onChange={uploadFunction}
                      style={{ display: 'none' }}
                      name="myfile"
                    />
                  </span>
                </label>
                <UploadText sx={{ mb: 0, mt: 0 }}>
                  <label className="filebutton" style={{ cursor: 'pointer', marginRight: 10 }}>
                    {isDragOver ? 'Drop images here' : 'Add Photos'}
                    <span>
                      <input
                        accept="image/png,image/jpg, image/jpeg"
                        type="file"
                        id="myfile"
                        onChange={uploadFunction}
                        style={{ display: 'none' }}
                        name="myfile"
                      />
                    </span>
                  </label>
                </UploadText>
              </DashedUploadBox>
            )}

                         {_state?.image?.length > 0 && (
               <Box
                 sx={{ 
                   display: 'flex', 
                   alignItems: 'center', 
                   gap: 1,
                   mt: 2,
                   width: '100%'
                 }}
               >
                 <TextField
                   sx={{ 
                     flex: 1,
                     '& .MuiOutlinedInput-root': {
                       height: '40px',
                       '& fieldset': {
                         borderColor: '#ccc',
                       },
                       '&:hover fieldset': {
                         borderColor: '#999',
                       },
                       '&.Mui-focused fieldset': {
                         borderColor: '#007bff',
                       },
                     },
                     '& .MuiInputBase-input': {
                       padding: '8px 12px',
                       fontSize: '14px',
                     }
                   }}
                   onChange={(e) => handle('imgMsg', e.target.value)}
                   className={classes.root}
                   inputProps={{ style: { color: '#1E3625', zIndex: 20 } }}
                   placeholder={'Type your message here'}
                 />
                 <SendButton 
                   onClick={sendImage}
                   sx={{
                     height: '40px',
                     width: '40px',
                     minWidth: '40px',
                     display: 'flex',
                     alignItems: 'center',
                     justifyContent: 'center',
                     flexShrink: 0
                   }}
                 >
                   <img src={send} alt="send" style={{ width: '16px', height: '16px' }} />
                 </SendButton>
               </Box>
             )}
          </Box>

          <RedButton onClick={handleClose} sx={{ width: '100%', mt: 2 }}>
            Cancel
          </RedButton>
        </Box>
      </Modal>
    </div>
  );
};

export default ImageUpload;
